// extracted by mini-css-extract-plugin
module.exports = {"Infobox":"Infobox_Infobox__x5yn7","Icon":"Infobox_Icon__LIqAc","TitleContainer":"Infobox_TitleContainer__VYyrR","Text":"Infobox_Text__xE2bI"};